/* snapshots.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { SplitView, SplitViewCol } from "../components/split-view";
import { List } from "../components/list";
import { InfoPanel } from "../components/info-panel";
import theme from "../theme";
import { useSnapshots } from "../state/snapshots";
import getEditorStateClass from "../state/get-editor-state";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { editorViewAtom } from "../state/editor-view";
import { editorStateAtom } from "../state/editor-state";
import { historyWriteAtom } from "../state/history";
var _26 = "._16jlkb7n{flex-grow:1}";
var _25 = "._1bsb1osq{width:100%}";
var _24 = "._1e0c1txw{display:flex}";
var _23 = "._vwz41tcg{line-height:24px}";
var _22 = "._4t3i1tcg{height:24px}";
var _21 = "._1di61emw:active{background-color:rgba(203,166,247,.6)}";
var _20 = "._1hvw1o36:focus{outline-width:medium}";
var _19 = "._49pcglyw:focus{outline-style:none}";
var _18 = "._nt751r31:focus{outline-color:currentColor}";
var _17 = "._d0altlke:hover{cursor:pointer}";
var _16 = "._30l35y2n:hover{color:#cdd6f4}";
var _15 = "._irr31wye:hover{background-color:rgba(203,166,247,.4)}";
var _14 = "._1h5m1y44+._1h5m1y44{margin-left:4px}";
var _13 = "._19itglyw{border:none}";
var _12 = "._2rkoyh40{border-radius:2px}";
var _11 = "._v564111k{transition:background .3s,color .3s}";
var _10 = "._1p1dangw{text-transform:uppercase}";
var _9 = "._bfhk1ojv{background-color:rgba(205,214,244,.1)}";
var _8 = "._syazryvq{color:rgba(205,214,244,.8)}";
var _7 = "._1wyb1skh{font-size:11px}";
var _6 = "._1dyzt94y{letter-spacing:1px}";
var _5 = "._k48p1nn1{font-weight:400}";
var _4 = "._19bv19bv{padding-left:10px}";
var _3 = "._n3tdi2wt{padding-bottom:6px}";
var _2 = "._u5f319bv{padding-right:10px}";
var _ = "._ca0qi2wt{padding-top:6px}";
var ActionButton = function ActionButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21]), /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: ax(["_ca0qi2wt _u5f319bv _n3tdi2wt _19bv19bv _k48p1nn1 _1dyzt94y _1wyb1skh _syazryvq _bfhk1ojv _1p1dangw _v564111k _2rkoyh40 _19itglyw _1h5m1y44 _irr31wye _30l35y2n _d0altlke _nt751r31 _49pcglyw _1hvw1o36 _1di61emw"])
  }, children));
};
var ListItem = function ListItem(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_22, _23, _24, _25]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_4t3i1tcg _vwz41tcg _1e0c1txw _1bsb1osq"])
  }, children));
};
var ListItemTitle = function ListItemTitle(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_26]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n"])
  }, children));
};
export function SnapshotsList(_ref4) {
  var snapshots = _ref4.snapshots,
    deleteSnapshot = _ref4.deleteSnapshot,
    loadSnapshot = _ref4.loadSnapshot;
  return /*#__PURE__*/React.createElement(List, {
    getKey: function getKey(item) {
      return item.name + item.timestamp;
    },
    items: snapshots,
    title: function title(item) {
      return /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(ListItemTitle, null, item.name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ActionButton, {
        onClick: function onClick() {
          return deleteSnapshot(item);
        }
      }, "delete"), /*#__PURE__*/React.createElement(ActionButton, {
        onClick: function onClick() {
          return loadSnapshot(item);
        }
      }, "restore")));
    }
  });
}
export default function SnapshotTab() {
  var _useSnapshots = useSnapshots(),
    _useSnapshots2 = _slicedToArray(_useSnapshots, 2),
    snapshots = _useSnapshots2[0],
    snapshotsDispatch = _useSnapshots2[1];
  var editorView = useAtomValue(editorViewAtom);
  var _useAtom = useAtom(editorStateAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    editorState = _useAtom2[0],
    setEditorState = _useAtom2[1];
  var historyDispatcher = useSetAtom(historyWriteAtom);
  var loadSnapshot = React.useCallback(function (snapshot) {
    var EditorState = getEditorStateClass();
    if (!editorState) return;
    if (!editorView) return;
    var newState = EditorState.create({
      schema: editorState.schema,
      plugins: editorState.plugins,
      doc: editorState.schema.nodeFromJSON(snapshot.snapshot)
    });
    editorView.updateState(newState);
    setEditorState(newState);
    historyDispatcher({
      type: "reset",
      payload: {
        state: editorView.state
      }
    });
  }, [editorView, editorState]);
  var deleteSnapshot = React.useCallback(function (snapshot) {
    snapshotsDispatch({
      type: "delete",
      payload: {
        snapshot: snapshot
      }
    });
  }, [snapshotsDispatch]);
  return /*#__PURE__*/React.createElement(SplitView, {
    testId: "__prosemirror_devtools_tabs_snapshots__"
  }, /*#__PURE__*/React.createElement(SplitViewCol, {
    noPaddings: true,
    grow: true
  }, snapshots.length ? /*#__PURE__*/React.createElement(SnapshotsList, {
    snapshots: snapshots,
    loadSnapshot: loadSnapshot,
    deleteSnapshot: deleteSnapshot
  }) : /*#__PURE__*/React.createElement(InfoPanel, null, "No saved snapshots yet. Press \"Save Snapshot\" button to add one.")));
}